import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from 'react-bem-helper'

import './index.css'

const classes = new BEMHelper('grid')

export function Grid ({
  children,
  list,
}) {
  return (
    <div {...classes('', { list })}>
      {children}
    </div>
  )
}

Grid.propTypes = {
  children: PropTypes.any,
  list: PropTypes.bool,
}

export function Col ({ children, multiple, image }) {
  return (
    <div {...classes('item', { multiple, image })}>
      {children}
    </div>
  )
}

Col.propTypes = {
  multiple: PropTypes.bool,
  image: PropTypes.bool,
  children: PropTypes.any,
}

export function BigCol ({ children, multiple, image }) {
  return (
    <div {...classes('fullwidthitem', { })}>
      {children}
    </div>
  )
}

BigCol.propTypes = {
  children: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Grid/index.js